
import React from 'react'
import { green, purple, amber } from '@mui/material/colors';
import { Avatar, Tooltip } from '@mui/material';
import { useObjectProperty } from '../shared/_helpers';
import { getUserInitialsEdit, QA_ROLES } from '../section_sf/Utils';

export const AvatarComponent = (props) => {
    let { context, bcpRequest, property, columnValue } = props;
    let [latestObject,] = useObjectProperty(context, bcpRequest, property);


    // This function retrieves the full name of the user
    const getUserFullName = (userObject) => {
        let fullNameText = "No User Chosen";
        if (userObject) {
            fullNameText = userObject;
        }
        return fullNameText
    }
    // This function retrieves the color for different QA columns
    const getAvatarColor = (columnValue) => {
        let avatarColor = ""
        switch (columnValue) {
            case QA_ROLES.CTAG_AG:
                avatarColor = purple[500]
                break;
            case QA_ROLES.SQA:
                avatarColor = green[500]
                break;
            case QA_ROLES.QA_IN_FACTORY:
                avatarColor = amber[500]
                break;
            default:
                avatarColor = amber[500]
                break;
        }
        return avatarColor;
    }

    return (
        <Tooltip title={getUserFullName(latestObject)} placement={'top'} arrow><Avatar
            sx={{ backgroundColor: getAvatarColor(columnValue), float: 'left', marginRight: '5px' }}>
            {getUserInitialsEdit(latestObject)}
        </Avatar>
        </Tooltip>
    )
}